import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@services";
import { ToastrService } from "ngx-toastr";
import { Observable, catchError } from "rxjs";
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _router: Router,
    private _toastService: ToastrService,
    private _translateService: TranslateService,
  ) {}

  private _handleError(response: HttpErrorResponse): Observable<HttpEvent<unknown>> {
    if (response?.url?.endsWith("users/1/me")) {
      throw response;
    }

    const errorCode = response?.error?.errorCode;

    if (!response?.url?.endsWith("is-missing-kyc-data")) {
      this._toastService.error(
        this._translateService.getTranslation(
          errorCode ? `error.${errorCode}` : "error.client.generic",
        ),
      );
    }

    throw response;
  }

  private _handleSessionExpiredError(): void {
    this._toastService.error(this._translateService.getTranslation("error.client.sessionExpired"));
    this._router.navigate(["/auth/login"]);
  }

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (request.url.endsWith("users/1/login")) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error.status === HttpStatusCode.Forbidden &&
          !request.url.endsWith("users/1/add-authenticated") &&
          !request.url.endsWith("is-missing-kyc-data")
        ) {
          this._handleSessionExpiredError();
          throw error;
        }

        return this._handleError(error);
      }),
    );
  }
}
